"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowContent = void 0;
var body_1 = require("./body");
var footer_1 = require("./footer");
var header_1 = require("./header");
exports.WorkflowContent = {
    Header: header_1.WorkflowContentHeader,
    Body: body_1.WorkflowContentBody,
    Footer: footer_1.WorkflowContentFooter,
};
